import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { AssuranceRow } from './AssuranceRow';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-111" data-mp="16okwuzd879zg">
      <div className="mx-auto max-w-4xl text-center" data-id="element-112" data-mp="12mr37b1g768s">
        <p className="inline-flex items-center rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-113" data-mp="12k4uv96qgmpi">
          Pour les formatrices ongulaires
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-114" data-mp="1q9z6jnfbg586">
          Préparez votre prochain cours en <Accent data-id="element-115" data-mp="ex556qwtax2d">quelques minutes</Accent> — sans repartir de zéro.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-116" data-mp="9x0w3ly8h4m6">
          Le système Ready-to-Teach pour structurer leçons, démonstrations, exercices, corrections et
          évaluations — sans tout préparer vous-même.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Nail Educator Ready — Édition Française : les 6 volumes et des pages intérieures sur tablette, ordinateur et téléphone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(120, 96, 56, 0.22))'
    }} data-id="element-117" data-mp="2zg6dgquicxw1" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-118" data-mp="2gr00lkgeb0i5">
        <strong className="font-semibold text-brand-charcoal" data-id="element-119" data-mp="2koe4cwlb4g2r">Nail Educator Ready™</strong> transforme votre
        expertise technique en une méthode d’enseignement structurée. De la science de l’ongle aux
        techniques avancées, jusqu’au troubleshooting et à l’évaluation : ouvrez le système, choisissez
        ce que vous enseignez et commencez.
      </p>

      <p className="mt-5 text-center font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-gold" data-id="element-120" data-mp="chkgszjvuxe9">
        Accès numérique immédiat · 6 volumes + 5 bonus
      </p>

      <CtaBlock label="Oui ! Je veux le système" className="mt-7" data-id="element-121" data-mp="3ji6fte9eseb" />
      <AssuranceRow className="mt-5" data-id="element-122" data-mp="108g1lcpx8sc0" />
    </section>;
}